/**
 * Created by alex.shmaltsuev on 2016-06-20.
 */

import initialState from '../store/initialstate';
import C from '../constants/faq';

export default (state = initialState().faq, action = null) => {
    switch(action.type){
        case C.GET_FAQ_LIST:
            return state.set(C.FAQ_LIST,action.payload);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/faq.js